export default {
      id: "icon--close-nav-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--close-nav-usage",
      toString: function () {
        return this.url;
      }
    }